<template>
  <div class="eventComp_mode_3 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <multiLevelFold_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsId="currSportsDetail.sportsId"
        :tabType="tabType"
        :tableMode="tableMode"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="isScrollFlag"
        :variableColWidthVw="variableColWidthVw"
        :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
        :defaultWidthVwNum="defaultWidthVwNum"
        :tableColumnData="tableColumnData"
        :tableData="tableData"
        @toParentEvent="toParentEventHandler"
        v-show="tableData && tableData.length > 0"
      ></multiLevelFold_table>
    </div>
  </div>
</template>

<script>
// 适用： 非对抗类 射箭排名赛 出场名单 （普通表格）
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_3',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    tabType: {
      type: String, //确定数据来自于 出场名单'startList'  || 本场数据'localData',
      default: '',
    },
    competitorType: {
      type: String, //竞赛者的类型 A || D || T,
      default: '',
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_3 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_3',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: null,
      tableCellDefaultWidthVw: 13.88,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      currModeObj: null,
      renderModeList: [
        {
          modeName: '', //从0开始计算
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: [
            'NCB',
            'SJP',
            'SMT',
            'LUG',
            'BOB',
            'ARC',
            'SWM',
            'WSU',
            'ROW',
            'RCB',
            'DIV',
            'FEN',
            'STK',
            'SSK',
            'CCS',
            'BTH',
            'SMT',
            'SBD',
            'FRS',
          ],
        },
        {
          modeName: '', //从0开始计算
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['SKN', 'GAR', 'SHO', 'TKW', 'ALP', 'FSK'],
          isTabType: 'startList',
        },
        {
          modeName: '', //从0开始计算
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 7.68,
          sportsIdArr: ['TKW'],
          isTabType: 'localData',
        },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 6.94,
          sportsIdArr: ['ATH', 'GRY', 'ATW', 'ATM'],
          isTabType: 'startList',
        },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 6.94,
          sportsIdArr: ['ATH', 'GRY', 'ATW', 'ATM'],
          isTabType: 'localData',
        },
        // {
        //   modeName: '',
        //   variableColWidthVw: [],
        //   tableCellDefaultWidthVw: 6.94,
        //   sportsIdArr: ['GRY'],
        //   isTabType: 'startList',
        // },
        // {
        //   modeName: '',
        //   variableColWidthVw: [],
        //   tableCellDefaultWidthVw: 6.94,
        //   sportsIdArr: ['GRY'],
        //   isTabType: 'localData',
        // },
        // {
        //   modeName: '',
        //   variableColWidthVw: [],
        //   tableCellDefaultWidthVw: 11.1,
        //   sportsIdArr: ['GAR'],
        //   isTabType: 'startList',
        // },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 8.33,
          sportsIdArr: ['GAR', 'EQU'],
          isTabType: 'singleResult',
        },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 6.94,
          sportsIdArr: ['GRY'],
          isTabType: 'combinedResult',
        },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 6.25,
          sportsIdArr: ['GAR'],
          isTabType: 'combinedResult',
        },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['SJP', 'ALP', 'SKN', 'BOB'],
          isTabType: 'combinedResult',
          resultKey: 'result_combined',
        },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['SJP', 'SBD', 'SKN', 'BOB'],
          isTabType: 'localData',
          resultKey: 'result_single',
        },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['SBD'],
          isTabType: 'teamResult',
        },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['BOB'],
          isTabType: 'teamResult',
        },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['SKN'],
          isTabType: 'teamResult',
          resultKey: 'result_team',
        },
        // {
        //   modeName: '',
        //   variableColWidthVw: [],
        //   sportsIdArr: ['SHO'],
        //   tableCellDefaultWidthVw: 11.1,
        //   isTabType: 'startList',
        // },
        {
          modeName: '', //从0开始计算
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 4.16,
          sportsIdArr: ['FEN'],
          isTabType: 'localData',
        },
        // {
        //   modeName: '',
        //   variableColWidthVw: [],
        //   tableCellDefaultWidthVw: 11.1,
        //   sportsIdArr: ['SWM'],
        //   isTabType: 'compreResult',
        // },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['SKN', 'BOB', 'ALP', 'FSK'],
          isTabType: 'singleResult',
          resultKey: 'result_single',
        },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['SKN', 'BOB'],
          isTabType: 'compreResult',
          resultKey: 'result_combined',
        },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['SWM', 'ALP', 'FSK'],
          isTabType: 'compreResult',
        },
      ],
    }
  },
  beforeCreate() {},
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (modeItem.isTabType) {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
                modeItem.isTabType === this.tabType
              ) {
                this.currModeObj = modeItem
              }
            } else {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId)
              ) {
                this.currModeObj = modeItem
              }
            }
          })
        }
        console.debug(
          'tabType:',
          this.tabType,
          this.datas,
          this.currModeObj,
          this.currSportsDetail
        )

        this.computedModeData(
          JSON.parse(
            JSON.stringify(
              this.currModeObj && this.currModeObj.resultKey
                ? this.datas[this.currModeObj.resultKey]
                : this.datas
            )
          )
        )
      })
    },
    toParentEventHandler(data) {
      console.debug(data)
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data) {
      console.debug(
        'computedModeData:',
        data,
        this.currModeObj,
        this.competitorType
      )
      if (data && data.data) {
        this.tableTotal = data ? data.length : 0
        const table_headArr = data.table_head

        // 表头
        const headColumns = []
        table_headArr.forEach((colums, colIndex) => {
          if (colums && colums.map_key_arr.length > 0) {
            headColumns.push({
              colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
              colTitle: colums.name ? colums.name : '',
            })
          }
        })

        const otherColumns = headColumns
        let customColumn = null
        let competitorType = this.competitorType
        if (
          ['SHO'].includes(this.currSportsDetail.sportsId) &&
          this.currModeObj.isTabType === 'startList'
        ) {
          // 射击的出场名单单人和团体都按单人列表展示
          competitorType = 'A'
        }
        if (
          competitorType === 'T' ||
          (['D'].includes(competitorType) &&
            ['FSK'].includes(this.currSportsDetail.sportsId))
        ) {
          customColumn = {
            prop: 'teamLogo-teamName', //fristColumnPropArr.join('-'),
            label: '国家/地区',
            // widthVw:
            //   this.currModeObj.variableColWidthVw[
            //     this.currModeObj.sportsIdArr.indexOf(
            //       this.currSportsDetail.sportsId
            //     )
            //   ], //对应列的宽度，单位vw
            className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
            // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          }
        } else {
          let playerProp =
            'playerName-playerLogo-playerGender-teamLogo-teamName'
          let playerClassName = 'columnPlayerGroupClass'
          if (
            ['FEN'].includes(this.currSportsDetail.sportsId) &&
            this.tabType === 'localData'
          ) {
            playerProp = `${playerProp}-${this.currSportsDetail.sportsId}`
            playerClassName = `${playerClassName}-${this.currSportsDetail.sportsId}`
          }
          customColumn = {
            prop: playerProp, //fristColumnPropArr.join('-'),
            label: '运动员',
            // widthVw:
            //   this.currModeObj.variableColWidthVw[
            //     this.currModeObj.sportsIdArr.indexOf(
            //       this.currSportsDetail.sportsId
            //     )
            //   ], //对应列的宽度，单位vw
            className: playerClassName, //单独定制的头部样式class
            // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          }
        }
        if (this.tableColumnData.length == 0) {
          let tableColumnData = []
          if (this.currModeObj.tableCellDefaultWidthVw) {
            this.tableCellDefaultWidthVw =
              this.currModeObj.tableCellDefaultWidthVw
          }
          let widthVw = this.tableCellDefaultWidthVw
          for (let i = 0; i < otherColumns.length; i++) {
            const item = otherColumns[i]
            if (['运动员', '姓名', '国家/地区'].includes(item.colTitle)) {
              // 特殊列
              tableColumnData.push(customColumn)
            } else {
              // 普通列
              console.debug('widthVw:', widthVw)
              let className = ''
              let prop = item.colKey
              if (
                ['FEN'].includes(this.currSportsDetail.sportsId) &&
                this.tabType === 'localData'
              ) {
                if (item.colKey.indexOf('bout_') > -1) {
                  className = 'FEN_boutItem'
                  prop = `${item.colKey}_FEN_boutItem`
                }
              }
              tableColumnData.push({
                prop: prop,
                label: item.colTitle,
                // widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                //   ? this.tableCellDefaultWidthVw / 2
                //   : this.tableCellDefaultWidthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
                // className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                //   ? 'expandTdClassName'
                //   : '', //单独定制的头部样式class
                widthVw,
                className,
                selected: '',
              })
            }
            // if (this.currModeObj.modeName === 'playerInforForColumn1') {
            //   if (i == 0) {
            //     tableColumnData.push(customColumn)
            //   }
            // } else if (this.currModeObj.modeName === 'playerInforForColumn2') {
            //   if (i == 1) {
            //     tableColumnData.push(customColumn)
            //   }
            // } else if (this.currModeObj.modeName === 'playerInforForColumn3') {
            //   if (i == 2) {
            //     tableColumnData.push(customColumn)
            //   }
            // }
          }
          this.defaultWidthVwNum = tableColumnData.length - 1 //减去这1列[运动员]
          this.tableColumnData = tableColumnData
        }
        this.tableData = data.data.map((rowData) => {
          return rowData
        })
        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.tableData:', this.tableData, this.tableColumnData)
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    notDataHandler() {
      this.tableTotal = 0
      this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
  }
}
</style>
